<template>
	<div :class="['video', { first }]">
		<div class="video-outer-wrapper">
			<VideoJs :videoServer="block.video.src" :autoplay="false" :cc="block.video.cc" class="videojs" />
		</div>
	</div>
</template>

<script>

	import VideoJs from "@/components/VideoJs"

	export default {
		props: ['block', 'first'],
		components: { VideoJs }
	}

</script>

<style lang="scss" scoped>

	@import "media";

	.video {

		&.first {
			margin-top:5vw; margin-left:5vw; margin-right:5vw;
			@include media(large) {
				margin-top:2.5vw; margin-left:2.5vw; margin-right:2.5vw;
			}
		}

		/deep/ {
			.video-js .vjs-tech {
				display:block; position:relative;
			}
		}
	}

	.video-outer-wrapper {
		position:relative; padding-bottom:56.25%;
		.videojs {
			position:absolute; top:0; left:0;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/BlogBlockTypes/Video.vue